import { format } from 'date-fns';
import React from 'react';

export const WindowDisplay = ({ window }: { window: { start: Date; end: Date } }) => (
  <>
    {format(window.start, 'p')}-{format(window.end, 'p')}{' '}
  </>
);
